import React from "react";
import { Phone, Instagram, Facebook } from "lucide-react";
import { CONTACT } from "../data";

export const Footer = () => (
  <footer className="bg-navy-950 text-cream py-14 border-t border-gold/20">
    <div className="mx-auto max-w-[1300px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10">
        <div className="flex items-center gap-4">
          <img src="/crane_light.png" alt="Kingdom Advancement" className="h-14 w-14 object-contain" />
          <div className="leading-tight">
            <p className="font-display text-2xl">KINGDOM ADVANCEMENT</p>
            <p className="text-gold text-[10px] uppercase tracking-luxe mt-1">Social Media Marketing, LLC · Est. 2024</p>
          </div>
        </div>

        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="flex items-center gap-4">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-gold/40 flex items-center justify-center hover:bg-gold hover:text-navy-deep transition-colors duration-300"><Instagram size={17} /></a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full border border-gold/40 flex items-center justify-center hover:bg-gold hover:text-navy-deep transition-colors duration-300"><Facebook size={17} /></a>
            <a href={CONTACT.phoneHref} aria-label="Phone" className="h-10 w-10 rounded-full border border-gold/40 flex items-center justify-center hover:bg-gold hover:text-navy-deep transition-colors duration-300"><Phone size={17} /></a>
          </div>
          <a href={CONTACT.phoneHref} className="text-cream/70 hover:text-gold transition-colors duration-300 tracking-wide">{CONTACT.phone}</a>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-cream/40 text-xs">
        <p>© {new Date().getFullYear()} Kingdom Advancement Social Media Marketing, LLC. All rights reserved.</p>
        <p className="font-display italic text-gold/70 text-sm">Let's advance your story.</p>
      </div>
    </div>
  </footer>
);
